import React from 'react'
import { SortIcon } from 'components/Icons/SortIcon'

export function IconsMock(): React.ReactElement {
  return (
    <div className="flex items-center gap-4">
      <SortIcon size={16} />
      <SortIcon size={20} />
      <SortIcon size={24} color="#06512f" />
    </div>
  )
}
